import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Profile from "@/pages/Profile";
import Feedback from "@/pages/Feedback";
import Prescription from "@/pages/Prescription";
import Appointment from "@/pages/Appointment";
import Screening from "@/pages/Screening";
import Contatti from "@/pages/Contatti";
import Psychoeducation from "@/pages/Psychoeducation";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/profilo" element={<Profile />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/ricetta" element={<Prescription />} />
            <Route path="/appuntamento" element={<Appointment />} />
            <Route path="/screening" element={<Screening />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/psicoeducazione" element={<Psychoeducation />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
